import ControlZoom from './ControlZoom';

export default ControlZoom;
